import canonical from 'components/seo/canonical';
import robots from 'components/seo/robots';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { MagazinePageProps } from 'pages/[magazine]';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import pageTitle from '../../../components/seo/title';
import Breadcrumb from '../common/breadcrumb';
import { getMagazineUrl } from '../util';
import BlogTile from './blog-tile';
import CatCate from './cat-cate-summer.jpg';
import CategoryTile from './category-tile';
import DogCate from './dog-cate-summer.jpg';
import InFocus from './in-focus';

type MagazineHomeProps = MagazinePageProps;

const MagazineHome: React.FC<MagazineHomeProps> = ({
  articles,
  inFocusArticle,
  mainCategories,
}) => {
  const { locale } = useRouter();
  const samePageCanonicalUrl = getMagazineUrl(undefined, false, locale);

  return (
    <>
      <Head>
        {pageTitle('Magazin')}
        {robots('index, follow')}
        {canonical(samePageCanonicalUrl)}
      </Head>

      <div className={'container'}>
        <div
          className={
            'text-primary-main m-auto my-6 w-full text-left lg:text-center'
          }
        >
          <h1
            className={'text-primary-main text-3xl leading-normal font-black'}
          >
            <FormattedMessage id="magazine:top-page:title" />
          </h1>
          <p
            className={
              'text-primary-main text-left text-xl leading-loose lg:text-center'
            }
          >
            <FormattedMessage id="magazine:top-page:subtitle" />
          </p>
        </div>
        <Breadcrumb root="Home" />
        {/* In focus section  */}
        {inFocusArticle?.fields && (
          <div className={'mb-9'}>
            <h2
              className={
                'text-primary-main mb-6 text-3xl leading-normal font-black'
              }
            >
              <FormattedMessage id="magazine:top-page:in-focus" />
            </h2>
            <InFocus article={inFocusArticle.fields} />
          </div>
        )}
        {/* Main theme section  */}
        <div className={'mb-9'}>
          <h2
            className={
              'text-primary-main mb-6 text-3xl leading-normal font-black'
            }
          >
            <FormattedMessage id="magazine:top-page:main-theme" />
          </h2>
          <div className={'flex lg:w-2/3'}>
            {mainCategories.map((theme) => {
              return (
                <div className={'mx-2 w-1/2 lg:mr-4'} key={theme.handle}>
                  <CategoryTile
                    title={theme.name}
                    href={getMagazineUrl({
                      mainCategory: theme,
                    })}
                    src={
                      theme.handle === 'hunde'
                        ? DogCate
                        : theme.handle === 'katzen'
                          ? CatCate
                          : null
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
        {/* Top articles section  */}
        {articles.length > 0 && (
          <div className={'mb-9'}>
            <h3
              className={
                'text-primary-main mb-6 text-3xl leading-normal font-black'
              }
            >
              <FormattedMessage id="magazine:top-page:top-articles" />
            </h3>
            <div className={'grid lg:grid-cols-3'}>
              {articles.map((article) => (
                <div key={article.fields.handle} className={'mb-6 lg:mr-6'}>
                  <BlogTile article={article.fields} isMagazineHome />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default MagazineHome;
